<div class="rewards-history-table-v2">
  <div *ngIf="loading" class="table-loading">
    <app-loading-table-shimmer
      [columns]="shimmerColumns"
      [rows]="5"
      [showHeader]="true">
    </app-loading-table-shimmer>
  </div>

  <div *ngIf="!loading && items.length === 0" class="empty-state-container">
    <app-empty-result
      image="/assets/images/empty_screen.png"
      title="No rewards to display!"
      description="No rewards to show for the selected period."
      [showAction]="false">
    </app-empty-result>
  </div>

  <div *ngIf="!loading && items.length > 0" class="rewards-table-container">
    <table class="rewards-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Total Rewards</th>
          <ng-container *ngFor="let column of columns; trackBy: trackByRuleId">
            <th>{{ ruleCountColumnHeader(column) }}</th>
            <th>{{ ruleAmountColumnHeader(column) }}</th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items; trackBy: trackByDate">
          <td>{{ formatDate(item.date) }}</td>
          <td data-label="Total Rewards">
            {{ formatRewardsTableCurrency(item.total_rewards) }}
          </td>
          <ng-container *ngFor="let column of columns; trackBy: trackByRuleId">
            <td [attr.data-label]="ruleCountColumnHeader(column)">
              {{ getRuleCount(item, column.rule_id) }}
            </td>
            <td [attr.data-label]="ruleAmountColumnHeader(column)">
              {{ getRuleAmount(item, column.rule_id) }}
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
</div>
